import type { ComponentProps } from "react";

export default function ChevronIcon(svgProps: ComponentProps<"svg">) {
  return (
    <svg
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="currentColor"
      aria-label="Chevron"
      {...svgProps}
    >
      <path d="M12.69 13.0607C13.2758 12.4749 13.2758 11.5251 12.69 10.9393L3.14407 1.3934C2.55828 0.807611 1.60854 0.807611 1.02275 1.3934C0.436964 1.97918 0.436964 2.92893 1.02275 3.51472L9.50803 12L1.02275 20.4853C0.436964 21.0711 0.436964 22.0208 1.02275 22.6066C1.60854 23.1924 2.55828 23.1924 3.14407 22.6066L12.69 13.0607ZM10.8008 13.5L11.6294 13.5L11.6294 10.5L10.8008 10.5L10.8008 13.5Z" />
    </svg>
  );
}
